[slot='body-desktop'] a,
[slot='body-mobile'] a {
  color: var(--grid-action-text-button-primary);
  text-decoration: underline;
}
[slot='body-desktop'] a:hover,
[slot='body-mobile'] a:hover {
  color: var(--grid-action-text-button-primary-hover);
}
